import { useStores } from '@littlebird/sdk';
import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

import { agentsStore } from '@/features/agents/agents.store';
import { FEATURES, useFeature } from '@/features/feature-flags';
import { logError } from '@/lib/errorLogging';
import { Panel, uiStore } from '@/stores/ui.store';

export const useSidebarState = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const firstSegment = path.split('/')[1];
    const panelKey = firstSegment ? `/${firstSegment}` : null;

    if (panelKey && Object.values(Panel).includes(panelKey as Panel)) {
      uiStore.setCurrentPanel(panelKey as Panel);
    }
  }, [location.pathname]);

  return {
    selectedPanel: uiStore.currentPanel,
    setSelectedPanel: (panel: Panel | null) => uiStore.setCurrentPanel(panel),
  };
};

export const useSidebarListsLoaded = () => {
  const { projects, agents } = useStores();
  const hasFeature = useFeature();
  const agentsUxEnabled = hasFeature(FEATURES.AGENTS_UX);

  useEffect(() => {
    void projects.ensureListLoadedFromStorage();
    if (!agentsUxEnabled) return;
    agents
      .ensureListLoadedFromStorage()
      .then(() => agentsStore.migrateLegacyRegistry())
      .catch((error: unknown) => {
        logError(error, 'Failed to load agents', { context: 'Sidebar' });
      });
  }, [projects, agents, agentsUxEnabled]);
};
